module.exports = __webpack_public_path__ + "img/logo_text.60917ba8.png";